export default __webpack_public_path__ + "locales/lv/Webhooks.json?hash=2b44453c4b43c1bc93a1f8f3ae5b7a00";